export enum DrugListSortKey {
  DRUG = 'drug',
  ELIGIBLE = 'eligible',
  PHARMA = 'pharma',
  DRUG_CLASS = 'drug_class',
  ACTIVE = 'active',
  RX_OTC = 'rx_otc',
  TYPE_CODE = 'type_code'
}
